export const buttonVariations = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  PLAIN: 'plain',
}

export const buttonSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}
